module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9252-1-p-1600-fda70201d0a4af740e92bfc46cdf19ea.jpeg";